import { BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { n_silcon, s_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

const ChallengeApplyModal = ({ isOpen, setIsOpen, onApply }) => {
  const { t } = useTranslation()

  return (
    <DSModal id="challenge-apply" isOpen={isOpen} setIsOpen={setIsOpen} size="lg">
      <DSModal.Title>{t(n_silcon.cta_pop.title)}</DSModal.Title>
      <DSModal.Content className="Body1-16Md text-gray-700">{t(n_silcon.cta_pop.content)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton type={BUTTON_TYPE.OUTLINE} size="lg" onClick={() => setIsOpen(false)}>
          <DSButton.Label>{t(s_common.cancel)}</DSButton.Label>
        </DSButton>
        <DSButton size="lg" onClick={onApply}>
          <DSButton.Label>{t(n_silcon.cta_pop.apply)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default ChallengeApplyModal
